import { BaseService } from '../../../infra/base.service'
import type { PartnerEntry } from './partner-entry.entity'
import type { PartnersEntriesRepository } from './partners-entries.repository'

export class PartnersEntriesService extends BaseService<PartnerEntry> {
    constructor(private rep: PartnersEntriesRepository) {
        super(rep)
    }

    async getTotals(partnerId: string): Promise<{ partnerId: string; pending: number; paid: number; released: number; date: Date }> {
        return await this.rep.getTotals(partnerId)
    }
}
